// *** ProfileBio Component ****
import React, { useEffect, useState, useRef } from "react";
import { Button, Modal } from "react-bootstrap";


const HeaderSearch = (props) => {

    return (
        <div>
            <Modal show={props.isSearch} onHide={props.handleClose} dialogClassName="custom-modal modal-fullscreen">
                <Modal.Header closeButton>
                    <div className="popupheader w-100 searcharea">
                          <i class="fa fa-search"></i>
                        <input type="search" className="form-control w-100 searchinput-mobile" placeholder="Search here" ></input>
                    </div>

                </Modal.Header>
                <Modal.Body>
                    <div >
                        
                    </div>
                </Modal.Body>
                
            </Modal>

        </div >
    );
};
export default HeaderSearch;
